export default __webpack_public_path__ + "static/media/kuchnia7.ce445212.jpg";